<template>
  <div class="container-fluid mt-5">
    <div>
      <card
        class="no-border-card"
        body-classes="px-0 pb-1"
        footer-classes="pb-2"
      >
        <template slot="header">
          <div class="row">
            <div class="col-6">
              <h3 class="mb-0">{{ $t("IMPORTS.IMPORTS_LIST") }}</h3>
            </div>
            <div class="col-6 text-right">
              <base-button
                type="primary"
                icon
                size="sm"
                @click="addImport()"
                v-if="$currentUserCan($permissions.PERM_CREATE_IMPORTS)"
              >
                <span class="btn-inner--icon">
                  <i class="fas fa-plus"></i>
                </span>
                <span class="btn-inner--text">{{
                  $t("IMPORTS.ADD_IMPORT")
                }}</span>
              </base-button>

              <notification-subscription
                v-if="$currentUserCan($permissions.PERM_VIEW_IMPORTS)"
                :objectType="'imports'"
                :events="{
                  CREATE: $t('NOTIFICATIONS.EVENT_CREATE'),
                  UPDATE: $t('NOTIFICATIONS.EVENT_UPDATE'),
                  DELETE: $t('NOTIFICATIONS.EVENT_DELETE'),
                }"
              />
            </div>
          </div>
        </template>

        <import-list-table />
      </card>
    </div>
  </div>
</template>

<script>
import { Button } from "element-ui";
import NotificationSubscription from "@/components/NotificationSubscription.vue";
import ImportListTable from "@/views/Pages/AdminModule/ImportModule/Partials/ImportListTable.vue";

export default {
  layout: "DashboardLayout",

  components: {
    ImportListTable,
    NotificationSubscription,
    [Button.name]: Button,
  },

  methods: {
    addImport() {
      this.$router.push({ name: "Add Imports" });
    },
  },
};
</script>
